var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMentorList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "0 0 161 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.3638,
    cy: 80.6787,
    r: 80,
    fill: "#E9ECEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3885_12312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3844 27.2774C69.7636 28.7432 63.9394 34.1509 61.9848 41.579C61.3136 44.1343 61.2346 48.0365 61.8071 50.473C63.6038 58.218 69.349 63.8039 77.2265 65.448C79.26 65.8838 83.0309 65.7452 85.3211 65.1509C92.4484 63.3087 97.5816 58.0992 99.4572 50.8493C100.128 48.2544 100.089 44.3126 99.3782 41.579C97.5421 34.6065 92.3102 29.4167 85.2619 27.5746C83.2679 27.0595 79.339 26.9011 77.3844 27.2774Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3252 70.5189C77.3054 70.618 76.4367 76.9566 75.3706 84.6224L73.4555 98.5675L76.9895 102.787C78.9244 105.124 80.5828 107.026 80.6815 107.026C80.7605 107.026 82.4189 105.144 84.3537 102.826C87.098 99.5381 87.868 98.5279 87.8285 98.1317C87.7693 97.5176 84.2747 71.9253 84.1168 71.0141L83.9983 70.3803H80.6618C78.8257 70.3803 77.3252 70.4397 77.3252 70.5189Z",
    fill: "#B2B2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.81 71.1726C58.5495 73.8467 48.7767 82.8199 45.1637 94.7049C43.7817 99.1815 43.525 102.192 43.604 112.275L43.6632 119.802L50.0403 119.861C64.4649 119.951 55.5656 119.901 79.5956 119.901C90.5135 119.901 115.429 119.861 115.429 119.822C116.08 109.439 118.228 95.0518 112.014 85.8307C106.999 78.264 99.3387 73.0544 90.4543 71.1528C88.1839 70.6774 87.5916 70.6774 87.5916 71.1132C87.5916 71.3112 88.4405 77.6697 89.4869 85.2761C90.5333 92.8627 91.3428 99.2806 91.2638 99.5381C91.0861 100.231 81.9451 111.047 81.2738 111.364C80.7605 111.621 80.6025 111.621 80.0892 111.364C79.3982 111.047 70.2769 100.231 70.0992 99.5183C70.0202 99.2608 70.8495 92.6844 71.9353 84.9196L73.8899 70.7764L73.1791 70.7962C72.804 70.7962 71.7379 70.9745 70.81 71.1726Z",
    fill: "#B2B2B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3885_12312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 93,
    fill: "white",
    transform: "translate(43.4658 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMentorList);
export default __webpack_public_path__ + "static/media/EmptyMentorList.72cc482cfbe1004d98e277328372eb57.svg";
export { ForwardRef as ReactComponent };